import _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import * as CampaignActions from './campaign.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';

export const campaignFeatureKey = 'campaign';

export interface State extends EntityState<any>{
  selectedCampaign: any;
  selectedOption: any;
  hinduTempleLocations: any[];
  search: string;
  updatedTicketingCampaign: any;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
  selectedCampaign: null,
  selectedOption: null,
  hinduTempleLocations: [],
  search: '',
  updatedTicketingCampaign: null,
});

export const reducer = createReducer(
  initialState,

  on(CampaignActions.loadCampaignList, state => state),
  on(CampaignActions.loadCampaignListSuccess, (state, action) => {
    let { data: list } = action;
    list = _.map(list, (campaign) => {
      if(campaign.campaignTypeData === null) {
        return campaign;
      }
      campaign.campaignTypeData.presetOptions = _.map(campaign.campaignTypeData.presetOptions, (option, index) => {
        return {
          ...option,
          index
        };
      });
      return campaign;
    });
    const clearedState = adapter.removeAll(state); 
    const result = adapter.upsertMany(list, clearedState);
    const entities = _.map(result.entities, entity => entity);
    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),
  on(CampaignActions.loadCampaignListFailure, (state, action) => state),

  on(CampaignActions.loadEditCampaignList, state => state),
  on(CampaignActions.loadEditCampaignListSuccess, (state, action) => {
    let { data: list } = action;
    list = _.map(list, (campaign) => {
      if(campaign.campaignTypeData === null) {
        return campaign;
      }
      campaign.campaignTypeData.presetOptions = _.map(campaign.campaignTypeData.presetOptions, (option, index) => {
        return {
          ...option,
          index
        };
      });
      return campaign;
    });
    const result = adapter.upsertMany(list, state);
    const entities = _.map(result.entities, entity => entity);
    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),
  on(CampaignActions.loadEditCampaignListFailure, (state, action) => state),

  on(CampaignActions.loadEventCampaignList, state => state),
  on(CampaignActions.loadEventCampaignListSuccess, (state, action) => {
    let { data: list } = action;
    list = _.map(list, (campaign) => {
      if(campaign.campaignTypeData === null) {
        return campaign;
      }
      campaign.campaignTypeData.presetOptions = _.map(campaign.campaignTypeData.presetOptions, (option, index) => {
        return {
          ...option,
          index
        };
      });
      return campaign;
    });
    const result = adapter.upsertMany(list, state);
    const entities = _.map(result.entities, entity => entity);
    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),
  on(CampaignActions.loadEventCampaignListFailure, (state, action) => state),

  on(CampaignActions.loadManageCampaignList, state => state),
  on(CampaignActions.loadManageCampaignListSuccess, (state, action) => {
    let { data: list } = action;
    list = _.map(list, (campaign) => {
      if(campaign.campaignTypeData === null) {
        return campaign;
      }
      campaign.campaignTypeData.presetOptions = _.map(campaign.campaignTypeData.presetOptions, (option, index) => {
        return {
          ...option,
          index
        };
      });
      return campaign;
    });

    const clearedState = adapter.removeAll(state); 
    const result = adapter.upsertMany(list, clearedState);
    const entities = _.map(result.entities, entity => entity);
    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),
  on(CampaignActions.loadManageCampaignListFailure, (state, action) => state),

  on(CampaignActions.loadReportCampaignList, state => state),
  on(CampaignActions.loadReportCampaignListSuccess, (state, action) => {
    let { data: list } = action;
    list = _.map(list, (campaign) => {
      if(campaign.campaignTypeData === null) {
        return campaign;
      }
      campaign.campaignTypeData.presetOptions = _.map(campaign.campaignTypeData.presetOptions, (option, index) => {
        return {
          ...option,
          index
        };
      });
      return campaign;
    });
    const result = adapter.upsertMany(list, state);
    const entities = _.map(result.entities, entity => entity);
    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),
  on(CampaignActions.loadReportCampaignListFailure, (state, action) => state),

  on(CampaignActions.loadReportCampaignList, state => state),
  on(CampaignActions.loadReportCampaignListSuccess, (state, action) => {
    let { data: list } = action;
    list = _.map(list, (campaign) => {
      if(campaign.campaignTypeData === null) {
        return campaign;
      }
      campaign.campaignTypeData.presetOptions = _.map(campaign.campaignTypeData.presetOptions, (option, index) => {
        return {
          ...option,
          index
        };
      });
      return campaign;
    });
    const result = adapter.upsertMany(list, state);
    const entities = _.map(result.entities, entity => entity);
    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),
  on(CampaignActions.loadReportCampaignListFailure, (state, action) => state),

  on(CampaignActions.loadPendingCampaignList, state => state),
  on(CampaignActions.loadPendingCampaignListSuccess, (state, action) => {
    let { data: list } = action;
    list = _.map(list, (campaign) => {
      if(campaign.campaignTypeData === null) {
        return campaign;
      }
      campaign.campaignTypeData.presetOptions = _.map(campaign.campaignTypeData.presetOptions, (option, index) => {
        return {
          ...option,
          index
        };
      });
      return campaign;
    });
    const result = adapter.upsertMany(list, state);
    const entities = _.map(result.entities, entity => entity);
    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),
  on(CampaignActions.loadPendingCampaignListFailure, (state, action) => state),

  on(CampaignActions.loadCampaign, state => state),
  on(CampaignActions.loadCampaignSuccess, (state, {data: campaign}) => {
    const result = adapter.updateOne({id: campaign.id, changes: campaign}, state);
    return {
      ...result,
      selectedCampaign: campaign
    };
  }),
  on(CampaignActions.loadCampaignFailure, (state, action) => state),

  on(CampaignActions.loadHinduDateLocationsSuccess, (state, { data: hinduTempleLocations }) => {
    return {
      ...state,
      hinduTempleLocations
    };
  }),

  on(CampaignActions.updateCampaign, (state, action) => {
    const { payload } = action;

    const campaign = _.get(state.entities, payload.id, null);
    if(_.isNull(campaign)) {
      return state;
    }

    let campaignPresetOptions = _.get(campaign, 'campaignTypeData.presetOptions', []);
    let payloadPresetOptions = _.get(payload, 'campaignTypeData.presetOptions', []);

    if(campaign.type === CAMPAIGN_TYPE.AUCTION) {
      campaignPresetOptions = _.map(campaignPresetOptions, campaignOption => {
        let find = _.find(payloadPresetOptions, { id: campaignOption.id }) || null;
        if(_.isNull(find)) {
          const soldCount = campaignOption.soldCount < campaignOption.count ?
            (campaignOption.soldCount + 1):
            campaignOption.soldCount;
          return { ...campaignOption, soldCount };
        }
        return campaignOption;
      });
    }

    payloadPresetOptions = _.map(payloadPresetOptions, payloadOption => {
      const find = _.find(campaignPresetOptions, { id: payloadOption.id });
      const index = _.get(find, 'index', null);
      return { ...payloadOption, index };
    });

    const unionPresetOptions = _.unionBy(payloadPresetOptions, campaignPresetOptions, 'id');
    const sortedUnionPresetOptions = _.sortBy(unionPresetOptions, ['index']);
    _.set(payload, 'campaignTypeData.presetOptions', sortedUnionPresetOptions);

    const result = adapter.upsertOne(payload, state);
    const entities = _.map(result.entities, entity => entity);
    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),

  on(CampaignActions.updateCampaignStatus, (state, action) => {
    const { payload } = action;

    const campaign = _.get(state.entities, payload.id, null);
    if(_.isNull(campaign)) {
      return state;
    }

    campaign.status = payload.status;
    const result = adapter.upsertOne(payload, state);
    const entities = _.map(result.entities, entity => entity);

    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),

  on(CampaignActions.updateCampaignList, (state, action) => {
    const { payload: list } = action;
    const result = adapter.upsertMany(list, state);
    const entities = _.map(result.entities, entity => entity);
    const selectedCampaign = (result.selectedCampaign) ?
      _.find(entities, entity => entity.id === result.selectedCampaign.id):
      null;
    const options = _.get(selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = (result.selectedOption) ?
      _.find(options, option => option.id === result.selectedCampaign.id):
      null;
    return {
      ...result,
      selectedCampaign,
      selectedOption
    }
  }),

  on(CampaignActions.selectCampaign, (state, action) => {
    const entities = _.map(state.entities);
    const selectedCampaign = _.isObject(action.payload) ?
      action.payload: _.find(entities, (campaign) => {
        return campaign.id === action.payload;
      });
    return {
      ...state,
      selectedCampaign
    };
  }),

  on(CampaignActions.selectOption, (state, action) => {
    const options = _.get(state.selectedCampaign, 'campaignTypeData.presetOptions', []);
    const selectedOption = _.find(options, (option) => {
      return option.id === action.payload;
    });
    return {
      ...state,
      selectedOption
    };
  }),

  on(CampaignActions.clearCampaignList, (state) => {
    return {
      ...adapter.removeAll(state),
      selectedCampaign: null,
      selectedOption: null
    }
  }),

  on(CampaignActions.clearCampaignSelected, (state) => {
    return {
      ...state,
      selectedCampaign: null
    }
  }),
  
  on(CampaignActions.updatePresetOptionSearch, (state, { payload: search }) => {
    return { ...state, search };
  }),

  on(CampaignActions.addCampaignPresetOptionSuccess, (state, { data }) => {
    const campaign = state.selectedCampaign;
    const campaignTypeData = campaign.campaignTypeData;
    const presetOptions = campaignTypeData.presetOptions;
    presetOptions.push(data);
    return { ...state, selectedCampaign: { ...campaign } };
  }),

  on(CampaignActions.updateCampaignPresetOptionSuccess, (state, { data }) => {
    const campaign = state.selectedCampaign;
    const campaignTypeData = campaign.campaignTypeData;
    const presetOptions = campaignTypeData.presetOptions;
    const index = _.findIndex(presetOptions, { id: data.id });
    presetOptions[index] = data;
    return { ...state, selectedCampaign: { ...campaign } };
  }),

  on(CampaignActions.deleteCampaignPresetOptionSuccess, (state, { option }) => {
    const campaign = state.selectedCampaign;
    const campaignTypeData = campaign.campaignTypeData;
    const presetOptions = campaignTypeData.presetOptions;
    _.remove(presetOptions, ({ id }) => {
      return _.isEqual(id, option.id);
    });
    return { ...state, selectedCampaign: { ...campaign } };
  }),
  on(CampaignActions.setStatusCamapignSuccess, (state, action) => {
    const campaignId = action.payload.campaignId;
    const newStatus = action.payload.newStatus;
    return adapter.updateOne({id:campaignId,changes:{status:newStatus}},state);
  }),
  on(CampaignActions.putCampaignByPropertiesSuccess, (state, action) => {
    return {
      ... state,
      updatedTicketingCampaign: action.updatedCampaign,
    }
  })
);

